import makeRequest from './base.request'

export const getPontuacaoUsuario = async () => {
    try {
        const response = await makeRequest.get(`conquistas/pontuacao`);
         // console.log('getPontuacaoUsuario ', response);
        if(typeof response !== 'object'){
            return response;
        }
        return response.body;
    } catch (error) {
        console.error(error);
    }
}

export const getNovaPontuacaoUsuario = async () => {
    try {
        const response = await makeRequest.get(`conquistas/listar-pontuacao`);
         console.log('getPontuacaoUsuario ', response);
        if(typeof response !== 'object'){
            return response;
        }
        return response.pontuacao;
    } catch (error) {
        console.error(error);
    }
}

export const calcularPontuacaoUsuario = async (idAccountStudent) => {
    try {
        const response = await makeRequest.put(`conquistas/pontuacao`, { ...(idAccountStudent && {idAccountStudent: idAccountStudent}) });
        // console.log('PUT pts', response)
        return response
    } catch (error) {
        console.error(error);
    }
}
